<template>
  <div class="region-page">
    <BContainer ref="bg-region-page" class="bg-region-page" fluid v-if="region">
      <div class="map_region" v-if="region && region.meta">
        <RegionMapHeader :scale-to="region.meta.scale" :center-to="region.meta.center" :countries="countries_id" />
      </div>
      <BContainer class="region-page__header">
        <BRow>
          <BCol cols="12" md="6" class="justify-content-center region-intro" v-if="region.players">
            <div>
              <h1>{{ translateRegion(region.region_id) }}</h1>
              <CustomSharingOptions class="mt-3 mb-3" :title="`${$t('social.region')} ${translateRegion(region.region_id)}`" />
              <p class="excerpt">
                <span>{{ regionDescription(region.region_id) }}</span>
              </p>
            </div>
          </BCol>
        </BRow>
      </BContainer>
    </BContainer>
    <BContainer class="bg-region-players pt-md-5 pt-1" ref="bg-region-players" fluid>
      <BContainer>
        <BRow class="float-filter d-block d-sm-block d-md-none">
          <BCol cols="12" class="pb-5">
            <b-button variant="primary" block class="mt-3"  v-b-modal.modal-menu>
             <IconCompass />  {{ $t('list.exploreBy') }}
            </b-button>
          </BCol>
        </BRow>
        <BRow>
          <BCol cols="12">
            <BRow>
              <BCol cols="3" class="d-none d-sm-none d-md-block mb-5 text-left">
                <div class="countries_filter">
                  <div class="mb-3">{{ $t('list.providersFilterLabel') }} {{ translateRegion(region.region_id) }}</div>
                  <BFormGroup>
                    <BFormRadioGroup
                    id="btn-radios-providers"
                    :options="listProviders"
                    v-model="selectedProvider"
                    name="radio-btn-stacked"
                    buttons
                    stacked />
                  </BFormGroup>

                  <div class="text-center btn-regions mt-5 mb-5">
                    <b-dropdown block size="lg" menu-class="w-100" variant="dark">
                      <template #button-content>
                        <IconWorld class="mr-2" /> {{ $t('list.regionLabel') }}
                      </template>
                      <b-dropdown-item-button v-for="region_item in allRegions" :key="`region_${region_item.region_id}`">
                        <RouterLink class="d-block w-100 text-center" :to="{ name: 'region.page', params: { region_id: region_item.region_id } }">{{ translateRegion(region_item.region_id) }}</RouterLink>
                        </b-dropdown-item-button>
                    </b-dropdown>
                  </div>

                  <AboutLinks />
                </div>
              </BCol>
              <BCol cols="12" md="8" offset-md="1" class="mb-5 pb-5">
                
                <div class="border-bottom pb-2 mb-5 text-center text-md-left">
                  <h3>{{ translateProvider(selectedProvider) }}</h3>
                </div>
                <PlayersGrid :players="playersFiltered" />
              </BCol>
            </BRow>
          </BCol>
        </BRow>

        <b-modal ref="modal-menu-region" hide-footer id="modal-menu">
          <template #modal-title>
            <IconCompass /> {{ $t('list.exploreBy') }}
          </template>
          <div class="countries_filter">
            <h4 class="text-center mb-3">{{ $t('list.providersFilterLabel') }} {{ translateRegion(region.region_id) }}</h4>
            <BFormGroup>
              <BFormRadioGroup
              id="btn-radios-providers"
              :options="listProviders"
              v-model="selectedProvider"
              name="radio-btn-stacked"
              buttons
              stacked />
            </BFormGroup>

            <div class="text-center btn-regions mt-5 mb-5">
              <b-dropdown block size="lg" menu-class="w-100" variant="dark">
                <template #button-content>
                  <IconWorld class="mr-2" /> {{ $t('list.regionLabel') }}
                </template>
                <b-dropdown-item-button v-for="region_item in allRegions" :key="`region_${region_item.region_id}`">
                  <RouterLink class="d-block w-100 text-center" :to="{ name: 'region.page', params: { region_id: region_item.region_id } }">{{ translateRegion(region_item.region_id) }}</RouterLink>
                  </b-dropdown-item-button>
              </b-dropdown>
            </div>

            <AboutLinks />
          </div>
        </b-modal>

      </BContainer>
    </BContainer>
  </div>
</template>

<script>
  import { filter } from 'lodash'

  import utilsMixins from '@/mixins/utils'
  import regionMixins from '@/mixins/region'

  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'
  import AboutLinks from '@/components/AboutLinks.vue'
  import PlayersGrid from '@/components/PlayersGrid.vue'
  import IconCompass from '@/components/IconCompass'
  import IconWorld from '@/components/IconWorld'
  import RegionMapHeader from '@/components/RegionMapHeader.vue'

  export default {
    name: 'Region',
    mixins: [regionMixins, utilsMixins],
    components: {
      AboutLinks,
      CustomSharingOptions,
      PlayersGrid,
      RegionMapHeader,
      IconWorld,
      IconCompass
    },
    data() {
      return {
        selectedProvider: 'all'
      }
    },
    mounted() {
      this.findRegion(this.$route.params.region_id)
      this.selectedProvider = `all`
    },
    watch: {
      selectedProvider() {

        if(this.$refs['bg-region-page']) {
          const top = this.$refs['bg-region-players'].offsetTop - 150
          window.scrollTo(0,top)
        }          

        this.$refs['modal-menu-region'].hide()
      }
    },
    computed: {
      playersFiltered() {
        if(this.region && this.selectedProvider == 'all')
          return this.region.players
        else if(this.region && this.selectedProvider != 'all') {
          return filter(this.region.players, player => {
            if(player.provider) {
              const providers = player.provider.split(";")
              if(providers.includes(this.selectedProvider)) {
                return player
              }
            }
          })
        }          
        else
          return []
      }
    }
  }
</script>

<style lang="scss">
  .map_region {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .opacity-map {
    opacity: 0.5;
  }

  .btn-regions {
    .btn-group {
      display: block;
      width: 100% !important;

      button {
        width: 100%;
      }
    }
  }

  .float-filter {
    position: sticky;
    top: 88vh;
    z-index: 990;
  }

  .region-page {
    &__header {
      @media (max-width: 768px) {
        margin-top: 25vh;
      }
    }

    .region-intro {
      border-right: dashed 1px #fff;
    }

    .excerpt {
      font-size: 21px;
      margin-bottom: 15px;    
    }

    .legend-map {
      display: inline-block;
      padding: 5px 15px;
      font-weight: 900;
      color: var(--app-color-light);
      background: var(--app-color-red);
    }
  }

  .countries_filter {
    position: sticky;
    top: 85px;

    label {
      margin-bottom: 5px;

      &.btn > span {
        font-size: 16px;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .router-link-active {
      color: var(--app-color-dark);
    }

    .btn-secondary {
      margin-bottom: 5px !important;
      color: #000;
      background: #1d1d1d30;
      border: none;
    }

    .btn {
      &.active {
        background: var(--app-color-red) !important;
      }
    }

    .btn-group-toggle {
      width: 100%;
    }
  }

  .bg-region-page {
    padding: 15vh 0 15px 0;
  }

  .bg-region-players {

    h3 {
      color: var(--app-color-black);
      text-transform: uppercase;
    }
  }
</style>
